import Button from "../ui/button";
import { TextBox } from "../primitives/text-box";
import LinkButton from "../menu/link-button/link-button";

interface ButtonWithSubtextProps {
  subText?: string;
  asLink?: boolean;
  path?: string;
  onClick?: () => void;
  disabled?: boolean;
  children?: React.ReactNode;
  // ... other button props
}

const ButtonWithSubtext = ({
  subText,
  asLink,
  path,
  onClick,
  disabled,
  children,
  ...buttonProps
}: ButtonWithSubtextProps) => (
  <div className="flex w-full flex-col items-stretch">
    {asLink && path ? (
      <LinkButton size={"4xl"} path={path} disabled={disabled} {...buttonProps}>
        {children}
      </LinkButton>
    ) : (
      <Button
        size={"lg"}
        onClick={onClick}
        disabled={disabled}
        {...buttonProps}
      >
        {children}
      </Button>
    )}
    {subText && <TextBox size={"lg"}>{subText}</TextBox>}
  </div>
);

export default ButtonWithSubtext;
